import React from "react";
import { Link } from "react-router-dom";
import "./press.css";

const PRESS_RELEASES = [
  {
    slug: "/press/deeptrading-major-product-release-2026-03-03",
    date: "March 3, 2026",
    title:
      "DeepTrading.ai Announces Major Product Release Introducing Trading Strategies, Backtesting, Market Analysis, Broker Portfolio Connections, and REST API",
    subtitle:
      "Most requested upgrades make DeepTrading.ai more actionable while keeping the experience simple, visual, and transparent.",
  },
];

const Press = () => (
  <div className="bodySec pressSec">
    <div className="container">
      <h2 className="text-center">
        <span>Press</span>
      </h2>
      <p className="pressIntro text-center">
        Official DeepTrading.ai press releases, product announcements, and media-ready updates.
      </p>

      <div className="row">
        <div className="col-12">
          <div className="pressListPanel">
            {PRESS_RELEASES.map((release) => (
              <article key={release.slug} className="pressReleaseCard">
                <div className="pressReleaseDate">{release.date}</div>
                <h3>{release.title}</h3>
                <p>{release.subtitle}</p>
                <Link className="defaultBtn pressReadBtn" to={release.slug}>
                  Read Full Release
                </Link>
              </article>
            ))}
          </div>
        </div>
      </div>
    </div>
  </div>
);

export default Press;
